import type {TimeZoneRules} from "./rules";

/** The provinces whose times move, said once. */
export const CHANGED =
  "From November 1, 2026, British Columbia, Alberta, the Northwest Territories and Manitoba keep daylight time all year.";

/** "America/Vancouver" → "Vancouver". */
export function cityOf(zone: string): string {
  return (zone.split("/").pop() ?? zone).replace(/_/g, " ");
}

/** What the standing notice says, or null when there is nothing to say. */
export function noticeWords(rules: TimeZoneRules | null): string | null {
  if (!rules || rules.state === "current") return null;
  if (rules.state === "stale")
    return `${CHANGED} This browser shows their times an hour early: update it, then reload.`;
  if (!rules.localZoneStale) return null;
  return `${CHANGED} Your appointments' times are corrected here, but other times may show ${cityOf(rules.localZoneStale)} an hour early until this browser is updated.`;
}
